<template>
  <div class="scroller">
    <div class="scroller__title" :class="'scroller__title--' + type">
      {{ title }}

      <span class="scroller__close" @click="$emit('close')">
        <svg width="32" height="32" viewBox="0 0 32 32">
          <path
              fill="#fff"
              fill-rule="evenodd"
              d="M4.55 4.54a15.54 15.54 0 1021.97 0 15.54 15.54 0 00-21.97 0zm19.1 16.15l-2.96 2.95-5.15-5.15-5.16 5.15-2.95-2.96 5.15-5.15-5.15-5.16 2.95-2.95 5.16 5.15 5.15-5.15 2.96 2.95-5.15 5.16z"
          />
        </svg>
      </span>
    </div>
    <perfect-scrollbar class="scroller__list">
      <div
          class="video"
          v-for="video in videos"
          :key="video.video"
          @click="$emit('video', video.video)"
      >
        <div class="video__disease">{{ disease(video.disease) }}</div>
        <div class="video__thumb">
          <img
              :src="
              `${basePreviewPath}${video.thumb}`
            "
              :alt="video.title"
              width="320"
          />
        </div>
        <div class="video__title">
          <span>{{ video.title }}</span>
          <span
              class="video__info"
              v-if="video.info"
              @click.stop="$emit('info', video.info)"
          >!</span
          >
        </div>
      </div>
    </perfect-scrollbar>
  </div>
</template>

<script>
import { PerfectScrollbar } from "vue2-perfect-scrollbar";
import "vue2-perfect-scrollbar/dist/vue2-perfect-scrollbar.css";
export default {
  components: {
    PerfectScrollbar
  },
  data() {
    return {
      basePreviewPath: process.env.NODE_ENV === 'production' ? '/direction/static_content/assets/redkie-bolezni/map/images/videos/' : '/images/previews/',
      diseases: {
        mps: "МПС I",
        pompe: "Помпе",
        fabri: "Фабри"
      }
    };
  },
  props: {
    title: {
      type: String,
      default: null
    },
    videos: {
      type: Array,
      default: null
    },
    type: {
      type: String,
      default: "__all"
    }
  },
  methods: {
    disease(code) {
      return this.diseases[code];
    }
  }
};
</script>

<style lang="scss" scoped>
.scroller {
  display: flex;
  flex-direction: column;
  overflow: hidden;

  &__close {
    position: absolute;
    right: 10px;
    top: 50%;
    transform: translate(0, -50%);
    cursor: pointer;
  }

  &__title {
    padding: 16px 64px 16px 16px;
    background: #848484;
    color: #ffffff;
    position: relative;

    &--mps {
      background: #a8d08d;
    }
    &--pompe {
      background: #bdd7ee;
    }
    &--fabri {
      background: #ffd965;
    }
    &--niemann-pika {
      background: #f78e94;
    }
  }

  &__list {
    flex-grow: 1;
    margin: 16px 0;
  }
}
.video {
  margin: 0 16px 16px;
  cursor: pointer;

  &:hover &__thumb {
    transform: translate(0, -2px);
  }

  &__disease {
    margin: 0 0 8px;
    font-size: 18px;
  }

  &__thumb {
    box-shadow: 0px 3px 6px rgba(#000, 0.16);
    margin: 0 0 8px;
    position: relative;
    transition: all 0.2s;

    &:after {
      content: "";
      position: absolute;
      background: url(../assets/play.svg);
      background-size: 100% 100%;
      width: 43px;
      height: 30px;
      left: 50%;
      top: 50%;
      transform: translate(-50%, -50%);
    }

    img {
      width: 100%;
      display: block;
      height: auto;
    }
  }
  &__title {
    font-size: 16px;
    line-height: 1.25;
    display: flex;
    align-items: center;
  }
  &__info {
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 26px;
    font-weight: bold;
    width: 32px;
    min-width: 32px;
    margin: 0 0 0 10px;
    height: 32px;
    background: linear-gradient(to bottom, #719fef, #4679d2);
    color: #fff;
    border-radius: 50%;
    box-shadow: 0px 3px 6px rgba(#000, 0.16);
  }
}
</style>
